import { useEffect } from 'react';

import { usePersistentState } from '@crossnokaye/ux-common';

import { LocalStorageKeys } from '@/constants';
import { useDidMountEffect } from '@/hooks/use-did-mount-effect';

/**
 * The desire is to have a persistent expanded state for the navigation menu.
 */
export const useStatefulExpandedNav = (
  expanded: boolean,
  setExpanded: (expanded: boolean) => void
) => {
  const [value, setValue] = usePersistentState<boolean>(
    localStorage,
    LocalStorageKeys.ExpandedLeftNav
  );

  // Only sync FROM localStorage TO Zustand on initial mount
  useEffect(() => {
    if (value !== undefined && value !== expanded) {
      setExpanded(value);
    }
  }, []); // Only run once on mount

  // Sync FROM Zustand TO localStorage when expanded changes
  useDidMountEffect(async () => {
    const setState = async () => {
      await setValue(expanded);
    };

    setState();
  }, [expanded]);
};
